import { makeObservable, observable } from "mobx"
import { TYPES } from "./ActivitiesConverter"
import ActivityPedaInstance from "./ActivityPedaInstance"
import ActivityResult from "./ActivityResult"


export class Proposition {
  ID
  Type
  Text
  media
  Debrief

  isCorrect = false
  incorrectText
  correctText


  userAnswer = null

  constructor(json) {
    Object.assign(this, json)

    makeObservable(this, {
      Text: observable,
      isCorrect: observable,
      media: observable,
      Debrief: observable,
      userAnswer: observable
    })
  }

  answer(val) {
    this.userAnswer = val
  }

  get userIsCorrect() {
    return this.userAnswer === this.isCorrect
  }
}

export class Swipe extends ActivityPedaInstance {

  ID
  Text
  media

  /** @type {Array<Proposition>} */
  Propositions = []

  incorrectText
  correctText


  // ceci est appelé avec le json de la première ligne, puis ensuite on y ajoute à la main les propositions avec les lignes suivantes du .data
  constructor(json) {
    super()
    Object.assign(this, json)
    this.Type = TYPES.SWIPE
  }

  observe() {
    super.observe()
    makeObservable(this, {
      correctText: observable,
      incorrectText: observable,
      Propositions: observable
    })
  }

  addProposition(json) {
    this.Propositions = [...this.Propositions, new Proposition(json)]
  }

  getProposition(id) {
    return this.Propositions.find(p => p.ID === id)
  }

  getIds() {
    return this.Propositions.map(p => p.ID)
  }

  getAnswer()  {

    // ici composer un message à envoyer au serveur
    const msg = this.Propositions.map(proposition => {
      return {ID: proposition.ID, userAnswer: proposition.userAnswer}
    })

    return msg
  }

  localCorrect() {
    let nb_user_correct = this.Propositions.filter(p => p.userIsCorrect).length
    let result = new ActivityResult()
    result.normalized_score =  nb_user_correct / this.Propositions.length;
    let correctThreshold = this.correctRatioThreshold ? this.correctRatioThreshold : 1
    result.is_correct = result.normalized_score >= correctThreshold //nb_missed === 0 && nb_wrong === 0,

    this.setResult(result)
  }

  reset() {
    this.Propositions.forEach(p => p.userAnswer = null)
    this.setResult(null)
  }


  // ceci est appelé en y passant un json déja complet du Reordonner, tel qu'on peut le trouver dans le fichier .activities
  fromJson(json) {
    Object.assign(this, json)
    this.Propositions = this.Propositions.map(c => new Proposition(c))
    this.observe()
    return this
  }

  getState() {
    let state = super.getState()
    state.Propositions = this.Propositions.map(p => { return { id : p.ID, userAnswer : p.userAnswer } })

    return state
  }
  setState(state) {
    super.setState(state)
    if(state.Propositions) {
      state.Propositions.forEach(p => {
        let prop = this.getProposition(p.ID)
        if (prop) {
          prop.userAnswer = p.userAnswer
        }
      })

    }
  }


}


export class SwipeFile {

  /** @type {Array<Swipe>} */
  all = []

  constructor(json, file) {

    let current = null

    json.forEach(row => {
      try {
        if(row.Type === TYPES.SWIPE || row.Type === "swipe") {
          current = new Swipe(row)
          this.all.push(current)
        }

        if(row.Type === "proposition") {
          current.addProposition(row)
        }

        if(row.Type === "debrief") {
          current.addDebrief(row, row.isCorrect)
        }


      }
      catch(err) {
        console.log("err", err)
        throw "ERREUR CREATION SWIPE : " + row.ID + " dans " + file
      }
    })
  }

  observeAll() {
    this.all.forEach(s => s.observe())
  }
  get(id) {
    return this.all.find(r => r.ID === id)
  }

  /**
   *
   * @param {Swipe} swipe
   * @returns {Array}
   */
  static toDataRows(swipe) {
    // ici on voudrait générer les lignes pour le qcm

    let rows = []

    // ligne de question
    rows.push({
      ID: swipe.ID,
      Type: TYPES.SWIPE,
      Text: swipe.Text,
      media: swipe.media,
      correctText: swipe.correctText,
      incorrectText: swipe.incorrectText,
    })

    // lignes de choices
    swipe.Propositions.forEach(p => {
      rows.push({
        ID: p.ID,
        Type: "proposition",
        Text: p.Text,
        media: p.media,
        isCorrect: p.isCorrect,
        correctText: p.correctText || swipe.correctText,
        incorrectText: p.incorrectText || swipe.incorrectText,
        Debrief: p.Debrief,
      })
    })

    // lignes de debriefs
    swipe.debriefs.forEach(d => {
      rows.push({
        ID: d.ID,
        Type: "debrief",
        Text: d.Text,
        media: d.media,
        isCorrect: d.isCorrect
      })
    })

    return rows
  }
}